var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('ag-grid-vue',_vm._b({staticClass:"ag-theme-material estilo-grilla",attrs:{"id":"grillaDetalle","grid-options":_vm.mergedGridOptions}},'ag-grid-vue',_vm.$attrs,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }